export enum AuthTab {
  LOGIN = 'login',
  REGISTER = 'register'
}